export default {
  shortcuts: {
    is: 'Flýtileiðir',
    en: 'Shortcuts',
  },
};
